import { useState, useEffect } from 'react';
import { engagementMetricsService } from '../../../services/engagementMetricsService';

export const useEngagementMetrics = (currentSessionId, sessionActive, sessionDuration, connectionQuality, chatMessages, isVideoEnabled, isAudioEnabled, appointmentData) => {
  const [engagementMetrics, setEngagementMetrics] = useState(null);

  useEffect(() => {
    if (!currentSessionId) return;

    const channel = engagementMetricsService?.subscribeToSessionMetrics(
      currentSessionId,
      (updatedMetrics) => {
        setEngagementMetrics(updatedMetrics);
      }
    );

    return () => {
      engagementMetricsService?.unsubscribe(channel);
    };
  }, [currentSessionId]);

  useEffect(() => {
    if (!currentSessionId || !sessionActive) return;

    const updateMetrics = async () => {
      const sentimentScore = 75 + Math.random() * 20;
      const sentimentLabel = sentimentScore > 85 ? 'positive' : sentimentScore > 70 ? 'neutral' : 'negative';

      await engagementMetricsService?.upsertMetrics({
        sessionId: currentSessionId,
        helperId: appointmentData?.helperId,
        sentimentScore,
        sentimentLabel,
        sessionDuration,
        connectionQuality,
        connectionLatency: 45 + Math.random() * 50,
        packetLossRate: Math.random() * 2,
        interactionCount: chatMessages?.length + (isVideoEnabled ? 1 : 0) + (isAudioEnabled ? 1 : 0),
        messageCount: chatMessages?.length,
        videoQuality: isVideoEnabled ? 'hd' : 'audio-only'
      });
    };

    const interval = setInterval(updateMetrics, 10000);
    updateMetrics();

    return () => clearInterval(interval);
  }, [currentSessionId, sessionActive, sessionDuration, connectionQuality, chatMessages, isVideoEnabled, isAudioEnabled, appointmentData]);

  return engagementMetrics;
};